export default __webpack_public_path__ + "84f299ce085c1ad028a421d785fd9eb5.png";